/**
 * CTA block — single massive "order now" call-to-action. Button mounts here.
 */
import { createIceButton } from '../ui/iceButton'

export function mountCtaBlock(): void {
  const host = document.getElementById('cta-block-ctas') as HTMLDivElement | null
  if (!host) return

  host.innerHTML = ''
  host.style.display = 'flex'
  host.style.gap = '18px'
  host.style.justifyContent = 'center'
  host.style.flexWrap = 'wrap'

  const waBtn = createIceButton({
    label: 'Chamar no WhatsApp',
    variant: 'ghost',
    size: 'large',
    onClick: () => window.open('https://wa.me/5547994499970', '_blank'),
  })
  const formBtn = createIceButton({
    label: 'Enviar mensagem',
    variant: 'cyan',
    size: 'large',
    onClick: () => {
      document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth', block: 'start' })
    },
  })

  host.appendChild(waBtn)
  host.appendChild(formBtn)
}
